import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import FormView from "../views/FormView.vue";
import ContactView from "../views/ContactView.vue";
import StatusView from "../views/StatusView.vue";
import SuivitView from "../views/SuivitView.vue";
import MentionsView from "../views/MentionsView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/suivi",
    name: "suivi",
    component: SuivitView,
  },
  {
    path: "/mentions",
    name: "mentions",
    component: MentionsView,
  },
  {
    path: "/form/:_id",
    name: "Form",
    component: FormView,
  },
  {
    path: "/status/:_id/:uid",
    name: "Status",
    component: StatusView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, _from, next) => {
  if (window.location.hostname === 'husqvarna-operation30ans.fr' || 
      window.location.hostname === 'www.husqvarna-operation30ans.fr') {
    const newUrl = `https://husqvarna-promo.fr${to.fullPath}`;
    window.location.href = newUrl;
    return;
  }
  next();
});

export default router;
